'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyedLense = exports.inspect = exports.equals = exports.map = exports.getProp = exports.setProp = exports.add = exports.id = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

exports.compose = compose;

var _curry = require('curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var debug = require('debug')('metapro:curry');

var id = exports.id = (0, _curry2.default)(function (x) {
  return x;
});
var add = exports.add = (0, _curry2.default)(function (a, b) {
  return a + b;
});
var setProp = exports.setProp = (0, _curry2.default)(function (key, value, obj) {
  return _extends({}, obj, _defineProperty({}, key, value));
});
var getProp = exports.getProp = (0, _curry2.default)(function (key, obj) {
  return obj[key];
});
var map = exports.map = (0, _curry2.default)(function (fn, array) {
  return array.map(fn);
});
var equals = exports.equals = (0, _curry2.default)(function (a, b) {
  return a === b;
});

var inspect = exports.inspect = (0, _curry2.default)(function (name, val) {
  debug('Inspect: Calling "%s" with', name, val);
  return val;
});

var keyedLense = exports.keyedLense = (0, _curry2.default)(function (key, fn, item) {
  var value = getProp(key, item);
  var newValue = fn(value);
  return setProp(key, newValue, item);
});

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function apply() {
    var args = arguments;
    var length = funcs.length;

    while (length--) {
      args = [funcs[length].apply(this, args)];
    }
    return args[0];
  };
}


//////////////////
// WEBPACK FOOTER
// ./app/utils/functional.js
// module id = 83
// module chunks = 1